export const guardantHealth = {
    fontFamilyImport: [],
  transitionMain: "all 300ms ease-in-out",

  fieldTopSpacing: 15,
  inputPaddingInline: 10,

  inputHeight: 35,
  inputWidth: '100',
  inputWidthUnits: "%",

  inputFontSize: 14,
  inputFontFamily: '"Raleway", sans-serif',
  inputColor: "#6D6E71",
  inputBackgroundColor: "#ffffff",
  inputFontWeight: 500,

  inputBorderColor: "#EBEBEB",
  inputBorderWidth: 1,
  inputBorderRadius: 0,

  inputHoverColor: "#6D6E71",
  inputHoverBorderColor: "#EBEBEB",
  inputHoverBackgroundColor: "#ffffff",

  // **********************************
  //  Select field
  selectTopSpacing: 15,
  selectPaddingInline: 10,

  selectHeight: 35,
  selectWidth: '100',
  selectWidthUnits: "%",

  selectFontSize: 14,
  selectFontFamily: '"Raleway", sans-serif',
  selectColor: "#6D6E71",
  selectBackgroundColor: "#ffffff",
  selectFontWeight: 500,

  selectBorderColor: "#EBEBEB",
  selectBorderWidth: 1,
  selectBorderRadius: 0,

  selectHoverColor: "#6D6E71",
  selectHoverBorderColor: "#EBEBEB",
  selectHoverBackgroundColor: "#ffffff",

  addSelectBackgroundImage: false,
  selectBackgroundImage: '',
  selectBackgroundImagePositionRight: 10,
  selectBackgroundImageSize: 20,

  // **********************************
  //  Text Area field
  textAreaTopSpacing: 15,
  textAreaPaddingInline: 10,

  textAreaHeight: 35,
  textAreaWidth: '100',
  textAreaWidthUnits: "%",

  textAreaFontSize: 14,
  textAreaFontFamily: '"Raleway", sans-serif',
  textAreaColor: "#6D6E71",
  textAreaBackgroundColor: "#ffffff",
  textAreaFontWeight: 500,

  textAreaBorderColor: "#EBEBEB",
  textAreaBorderWidth: 1,
  textAreaBorderRadius: 0,

  textAreaHoverColor: "#6D6E71",
  textAreaHoverBorderColor: "#EBEBEB",
  textAreaHoverBackgroundColor: "#ffffff",

  // **********************************
  //  placeholder
  placeholderColor: "#6D6E71",
  placeholderFontFamily: '"Raleway", sans-serif',
  placeholderFontSize: 14,
  placeholderFontWeight: 400,
  placeholderHoverColor: "#6D6E71",

  // **********************************
  // script
  addPlaceholders: false,
  removeFieldLabels: false,

  // **********************************
  //  field label
  fieldLabelBottomSpacing: 12,
  fieldLabelPadding: 0,
  fieldLabelFontSize: 14,
  fieldLabelColor: "#6D6E71",
  fieldLabelFontWeight: 500,
  fieldLabelColorAsterisk: "#6D6E71",
  fieldLabelAlignment: "column",
  fieldLabelFontFamily: '"Raleway", sans-serif',

  // **********************************
  //  description
  descriptionPaddingInline: 0,
  descriptionColor: "#6D6E71",
  descriptionFontSize: 16,
  descriptionFontWeight: 400,
  descriptionFontFamily: '"Raleway", sans-serif',
  descriptionTopSpacing: 10,

  // **********************************
  // checkbox

  addCheckbox: false,
  checkedCheckboxContent: "",
  checkboxInputSize: 20,
  checkboxBorderWidth: 1,
  checkboxBorderRadius: 2,
  checkboxUncheckedBorderColor: "#EBEBEB",
  checkboxUncheckedBackgroundColor: "#ffffff",
  checkboxCheckedBackgroundColor: "#FF0092",
  checkboxCheckedBorderColor: "#EBEBEB",
  checkboxCheckedColor: "#ffffff",
  checkboxAlignment: "none",
  checkboxLabelFontFamily: '"Raleway", sans-serif',
  checkboxLabelFontSize: 14,
  checkboxLabelFontWeight: 400,
  checkboxLabelColor: "#6D6E71",

  // **********************************
  // radio button

  addRadioButton: false,
  radioInputSize: 20,
  radioBorderWidth: 1,
  radioBorderRadius: 50,

  radioUncheckedBorderColor: "#EBEBEB",
  radioUncheckedBackgroundColor: "#ffffff",
  radioCheckedBackgroundColor: "#FF0092",
  radioCheckedBorderColor: "#EBEBEB",

  radioAlignment: "none",

  radioLabelFontFamily: '"Raleway", sans-serif',
  radioLabelFontSize: 14,
  radioLabelFontWeight: 400,
  radioLabelColor: "#6D6E71",

  // **********************************
  // submit button

  submitMarginTop: 30,
  submitFontSize: 14,
  submitFontFamily: "'Raleway', sans-serif",
  submitWidth: 160,
  submitWidthUnits: "px",
  submitHeight: 43,
  submitBorderRadius: 60,
  submitBorderWidth: 1,
  submitBackground: "#FF0092",
  submitColor: "#ffffff",
  submitBorderColor: "#FF0092",
  submitBackgroundHover: "#FF0092",
  submitBorderColorHover: "#FF0092",
  submitColorHover: "#ffffff",
  submitTextAlign: "center",
  submitButtonText: "Submit",
  submitFontWeight: 700,
  addBackgroundImage: false,
  submitBackgroundImage: '',
  submitBackgroundImagePositionRight: 10,
  submitBackgroundImageSize: 20,
  submitButtonAlign: "left",
};

  